import { useTranslation } from 'react-i18next';
import { useFormContext, useWatch } from 'react-hook-form';

import { LinkField } from 'common/forms/Field';

interface IProps {
    dateFieldName: string;
    hasServiceProvider?: boolean;
}

export const WebinarLinkField = ({
    dateFieldName,
    hasServiceProvider,
}: IProps) => {
    const [translate] = useTranslation();
    const { control } = useFormContext();

    const isServiceProviderWebinar = useWatch({
        name: `${dateFieldName}.isServiceProviderWebinar`,
    });

    if (hasServiceProvider && isServiceProviderWebinar) return null;

    return (
        <LinkField
            control={control}
            label={translate('webinarLink')}
            name={`${dateFieldName}.webinarLink`}
        />
    );
};
